import React from 'react';
import { StyledForms } from '@app/components/styled/form/Form';
import { FormSection } from '@app/components/styled/form/FormSection';
import { TextInput } from '@app/components';

export const OrganizationForm = () => {
  return (
    <StyledForms.Form>

      <FormSection.Section>
        <FormSection.Title>Informations générales</FormSection.Title>
        <FormSection.Content>

          <TextInput
            name="email"
            label="Email"
            autoCapitalize="none" />

        </FormSection.Content>
      </FormSection.Section>

    </StyledForms.Form>
  );
};
